import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import notify from 'devextreme/ui/notify';
import moment from 'moment';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { moduli } from '../../config';
import { DeklaracijeService } from './deklaracije.service';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Component({
  selector: 'app-deklaracije',
  templateUrl: './deklaracije.component.html',
  styleUrls: ['./deklaracije.component.scss'],
  providers: [DeklaracijeService],
})
export class DeklaracijeComponent implements OnInit {
  deklaracije: any;
  prikaziPaletePopupVisible = false;
  palete: any;
  proizvod: string;
  proizvodSifra: string;
  dodajPaletuPopupVisible = false;
  rBroj: number;
  brKomada: number = null;
  brPaleta: any;
  polovicna: boolean;
  maxKomada: number;
  idArtikl: number;
  idPlan: any;
  brKartona: number;
  idPalete: number;
  dodajUredi: string;
  obrisiPaletuPopupVisible = false;
  poruka: string;
  today: Date = new Date();
  odabraniDatum: string;
  user: any;
  glavniIspis = false;
  smjene: any;
  smjena = '';
  docDefinition: any = [];

  // PRAVA KORISNIKA
  pravaKorisnika = JSON.parse(sessionStorage.getItem('pravakorisnika'));
  trenutniPogled: any;
  pravaZaTrenutniPogled: any;
  prikaziStranicu = 0;
  // KRAJ PRAVA KORISNIKA

  popupDodajNoveNaljepniceZaIspisVisible: boolean = false;

  sifraArtikla: any;
  nazivArtikla: any;
  barkodArtikla: any;
  zaNarudzbu: boolean = false;
  kartonKolicina: any;
  kolicinaKartonaNaPaleti: any;
  kolicina: number;

  noviPlanovi: any[] = [];
  noveNalijepnice: any;
  idBarkoda: number;
  odabraniIdPlan: any;
  odabraniBarkod: any;
  filtriraniBarkodovi: any[] = [];

  sifraArtiklaIsEmpty: boolean = false;
  nazivArtiklaIsEmpty: boolean = false;
  kartonKolicinaIsEmpty: boolean = false;
  kolicinaKartonaNaPaletiIsEmpty: boolean = false;
  kolicinaOdabranogArtikla: any;
  idOdabranogArtikla: any;
  idBarkodOdabranogArtikla: any;

  constructor(private service: DeklaracijeService, private router: Router) {
    if (parseInt(localStorage.getItem('firma')) == 3) {
      this.router.navigate(['/dostavnica-hlad']);
    }
    this.smjene = [
      { id: 'all', naziv: 'SVE' },
      { id: 1, naziv: '1' },
      { id: 2, naziv: '2' },
      { id: 3, naziv: '3' },
    ];

    // PRAVA KORISNIKA
    this.trenutniPogled = moduli().naljepniceZaIspis;
    for (var i = 0; i < this.pravaKorisnika.length; i++) {
      //console.log(i);
      if (this.pravaKorisnika[i].smo_ime == this.trenutniPogled) {
        this.pravaZaTrenutniPogled = this.pravaKorisnika[i].sgm_prava;
        //console.log(this.pravaZaTrenutniPogled);
        if (this.pravaKorisnika[i].sgm_prava != 0) {
          this.prikaziStranicu = 1;
        } else {
          notify('Nemate prava.', 'error', 3000);
        }
        return;
      } else {
      }
    }
    // KRAJ PRAVA KORISNIKA
  }

  ngOnInit() {
    this.user = localStorage.getItem('iduser');
    this.odabraniDatum = moment(this.today).format('YYYY-MM-DD');
    this.dohvatiNaljepnice(this.odabraniDatum, this.smjena);
  }

  // Dohvati podatke
  dohvatiNaljepnice(datum, smjena) {
    // console.log(datum, smjena);
    this.poruka = 'Učitavanje...';
    this.deklaracije = [];
    this.service.dohvatiNaljepnice({ datum: datum, smjena: smjena }).subscribe((res) => {
      console.log(res);
      for (let data of res.data) {
        this.deklaracije.push({
          idPlan: data.planproizvodnje_idplanproizvodnje,
          idArtikl: data.artikal_ar_id,
          sifra: data.ar_sifra,
          naziv: data.ar_naziv,
          kolicina: data.pp_planiranakolicina,
          paleta: data.nd_ukupanbrojpaletanew,
          smjena: data.smjena_idsmjena,
          kartona: data.komadaukupno / data.bk_ukarton,
          komada: data.nd_brojkomada,
          datum:
            data.datumkadajezadannalog == null
              ? ''
              : data.datumkadajezadannalog, //moment(data.datumkadajezadannalog).format('DD.MM.YYYY.')
          idVrstaNaljepnice: data.dk_vrsta_naljepnice,
          vrstaNaljepnice: data.vrstanaljepnice,
          maxKomada: data.komadaukupno,
          lot: data.ar_lot,
        });
      }
      console.log(this.deklaracije);
      if (this.deklaracije.length > 0) {
        this.poruka = 'Učitavanje...';
      } else {
        this.poruka = 'Nema podataka za prikaz!';
      }
    });
  }

  dohvatiPaleteData(data) {
    // console.log(data);
    this.proizvod = data.data.naziv;
    this.proizvodSifra = data.data.sifra;
    this.maxKomada = data.data.maxKomada;
    this.idArtikl = data.data.idArtikl;
    this.idPlan = data.data.idPlan;
    this.brKartona = data.data.kartona;
    if (this.glavniIspis) {
      this.dohvatiPaleteIspis(this.idPlan);
    } else {
      this.dohvatiPalete(this.idPlan);
    }
  }

  dohvatiPaleteZaIspis(data) {
    this.glavniIspis = true;
    this.dohvatiPaleteData(data);
  }

  dohvatiPalete(idPlan) {
    this.glavniIspis = false;
    this.palete = [];
    this.service.dohvatiPalete({ idplanproizvodnje: idPlan }).subscribe((res) => {
      // console.log(res);
      if (res.success === true) {
        this.prikaziPaletePopupVisible = true;
        for (let paleta of res.data) {
          this.palete.push({
            idPalete: paleta.nd_id,
            idArtikl: paleta.artikal_ar_id,
            rBroj: paleta.nd_rednibrojnalepnice,
            redniBroj: paleta.nd_rednibrojnalepnice + '.',
            brKartona: paleta.nd_brojkartona,
            brKomada: paleta.nd_brojkomada,
            vrstaPalete: paleta.nd_polovicnapaleta,
            status: paleta.vrstapalete,
            lot: paleta.ar_lot,
            dopunjeno: paleta.nd_nadopunjeno === 1 ? 'DA' : '',
            ispisano: paleta.nd_ispisane_naljepnice === 1 ? 'DA' : '',
            sifraPoslovnice: paleta.po_sifra,
            radniNalog: paleta.nl_id,
          });
        }
        this.palete.reverse();
      }
    });
  }

  dohvatiPaleteIspis(idPlan) {
    this.palete = [];
    this.service.dohvatiPalete({ idplanproizvodnje: idPlan }).subscribe((res) => {
      // console.log(res);
      if (res.success === true) {
        for (let paleta of res.data) {
          this.palete.push({
            idPalete: paleta.nd_id,
            idArtikl: paleta.artikal_ar_id,
            rBroj: paleta.nd_rednibrojnalepnice,
            redniBroj: paleta.nd_rednibrojnalepnice + '.',
            brKartona: paleta.nd_brojkartona,
            brKomada: paleta.nd_brojkomada,
            vrstaPalete: paleta.nd_polovicnapaleta,
            status: paleta.vrstapalete,
            lot: paleta.ar_lot,
            dopunjeno: paleta.nd_nadopunjeno === 1 ? 'DA' : '',
            ispisano: paleta.nd_ispisane_naljepnice === 1 ? 'DA' : '',
            sifraPoslovnice: paleta.po_sifra,
            radniNalog: paleta.nl_id,
          });
        }
        this.palete.reverse();
        this.qrCodes();
      }
    });
  }

  // Paleta
  dodajPaletuPopup() {
    this.dodajUredi = 'Dodaj paletu';
    this.dodajPaletuPopupVisible = true;
    this.rBroj = this.palete.length + 1;
    this.brKomada = null;
    this.brPaleta = null;
    this.polovicna = false;
    this.idPalete = null;
  }

  dodajPaletu() {
    let params = {
      rednibrojnaljepnice: this.rBroj,
      idartikl: this.idArtikl,
      idplanproizvodnje: this.idPlan,
      brojkartona: this.brKartona,
      brojkomada: this.brKomada,
      brojpaletaDodavanje: this.brPaleta,
      polovicnapaleta: this.polovicna,
    };
    console.log(params);
    if (this.brKomada) {
      this.service.dodajPaletu(params).subscribe((res) => {
        console.log(res);
        if (res.success === true) {
          this.dodajPaletuPopupVisible = false;
          this.dohvatiPalete(this.idPlan);
          this.dohvatiNaljepnice(this.odabraniDatum, this.smjena);
          notify('Uspješno dodana nova paleta.', 'success', 3000);
        }
      });
    } else {
      notify('Nije unešen broj komada.', 'warning', 3000);
    }
  }

  urediPaletuPopup(data) {
    // console.log(data);
    this.dodajUredi = 'Uredi paletu';
    this.dodajPaletuPopupVisible = true;
    this.rBroj = data.data.rBroj;
    this.brKomada = data.data.brKomada;
    this.polovicna = data.data.vrstaPalete;
    this.idPalete = data.data.idPalete;
  }

  urediPaletu() {
    let params = {
      rednibrojnaljepnice: this.rBroj,
      brojkomada: this.brKomada,
      polovicnapaleta: this.polovicna,
      nd_id: this.idPalete,
      idkorisnik: this.user,
    };
    // console.log(params);
    this.service.urediPaletu(params).subscribe((res) => {
      // console.log(res);
      if (res.success === true) {
        this.dodajPaletuPopupVisible = false;
        this.dohvatiPalete(this.idPlan);
        this.dohvatiNaljepnice(this.odabraniDatum, this.smjena);
        notify('Uspješna promjena palete!', 'success', 3000);
      }
    });
  }

  obrisiPaletuPopup(data) {
    // console.log(data);
    this.idPalete = data.data.idPalete;
    this.obrisiPaletuPopupVisible = true;
  }

  obrisiPaletu() {
    let params = {
      nd_id: this.idPalete,
    };
    // console.log(params);
    this.service.obrisiPaletu(params).subscribe((res) => {
      console.log(res);
      if (res.success === true) {
        this.obrisiPaletuPopupVisible = false;
        this.dohvatiPalete(this.idPlan);
        this.dohvatiNaljepnice(this.odabraniDatum, this.smjena);
        notify('Uspješno obrisana paleta!', 'success', 3000);
      }
    });
  }

  // On Value Changed
  brojKomadaChanged(e) {
    // console.log(e);
    this.brKomada = e.value;
    if (this.brKomada < this.maxKomada) {
      this.polovicna = true;
    } else {
      this.polovicna = false;
    }
  }

  brojPaletaChanged(e) {
    //console.log(e);
    this.brPaleta = e.value;
  }

  redniBrojChanged(e) {
    // console.log(e);
    this.rBroj = e.value;
  }

  promjenaDatuma(e) {
    // console.log(e);
    this.odabraniDatum = moment(e.value).format('YYYY-MM-DD');
    // console.log(this.odabraniDatum);
    this.dohvatiNaljepnice(this.odabraniDatum, this.smjena);
  }

  promjenaSmjene(e) {
    // console.log(e);
    this.smjena = e.value;
    this.dohvatiNaljepnice(this.odabraniDatum, this.smjena);
  }

  // DxDataGrid
  onToolbarPreparing(e) {
    var toolbarItems = e.toolbarOptions.items;
    toolbarItems.unshift(
      {
        location: 'before',
        template: 'naslovTablice',
      },
      {
        location: 'after',
        template: 'odabirDatuma',
      },
      {
        location: 'after',
        template: 'odabirSmjene',
      }
    );
  }
  onCellPrepared(options) {
    // console.log(options);
    if (options.rowType == "data") {
      if (options.column.dataField === "smjena"){
        if (options.value == '1') {
          options.cellElement.classList.add('bojaSmjena1');
        }
        if (options.value == '2') {
          options.cellElement.classList.add('bojaSmjena2');
        }
        if (options.value == '3') {
          options.cellElement.classList.add('bojaSmjena3');
        }
      }
    }
  }

  closePopup() {
    this.prikaziPaletePopupVisible = false;
  }

  qrCode(data) {
    // console.log(data);
    let ct = [];
    ct.push({
      // qr:
      // 'Naziv artikla: ' + this.proizvod + '\n' +
      // 'Šifra artikla: ' + this.proizvodSifra + '\n' +
      // 'LOT: ' + data.data.lot + '\n' +
      // 'Redni broj palete: ' + data.data.rBroj + '\n' +
      // 'Broj komada: ' + data.data.brKomada + '\n' +
      // 'Broj kartona: ' + data.data.brKartona,
      qr:
        this.proizvod +
        ';' +
        this.proizvodSifra +
        ';' +
        data.data.lot +
        ';' +
        data.data.rBroj +
        ';' +
        data.data.brKomada +
        ';' +
        data.data.brKartona +
        ';' +
        data.data.sifraPoslovnice +
        ';' +
        data.data.idPalete +
        ';' +
        data.data.radniNalog +
        ';' +
        this.idPlan +
        ';' +
        data.data.status +
        ';' +
        data.data.idArtikl,
      fit: '150',
      alignment: 'center',
    });
    
    ct.push({ text: '\n' });
    ct.push({ text: 'Šifra proizvoda: ' + this.proizvodSifra });
    ct.push({ text: 'Naziv: ' + this.proizvod, fontSize: 13 });
    ct.push({ text: 'LOT: ' + data.data.lot });
    ct.push({ text: 'Status palete: ' + data.data.status });
    ct.push({ text: 'Redni broj palete: ' + data.data.rBroj });
    
    this.docDefinition = {
      info: { title: this.proizvodSifra + ' ' + this.proizvod },
      pageSize: { width: 226, height: 283 },
      pageMargins: [10, 10, 10, 10],
      content: ct,
    };
    
    if (data.data.lot !== null) {
      pdfMake.createPdf(this.docDefinition).open();
      this.service
        .oznacitiIspisanuNaljepnicu({ idnaljepnice: data.data.idPalete })
        .subscribe((res) => {
          console.log(res);
          if (res.success === true) {
            this.dohvatiPalete(this.idPlan);
          }
        });
    } else {
      notify('Nije moguće ispisati, paleta nema LOT!', 'warning', 3000);
    }
  }

  qrCodes() {
    console.log(this.palete);
    let ct = [];
    for (let paleta of this.palete) {
      ct.push({
        // qr:
        // 'Naziv artikla: ' + this.proizvod + '\n' +
        // 'Šifra artikla: ' + this.proizvodSifra + '\n' +
        // 'LOT: ' + paleta.lot + '\n' +
        // 'Redni broj palete: ' + paleta.rBroj + '\n' +
        // 'Broj komada: ' + paleta.brKomada + '\n' +
        // 'Broj kartona: ' + paleta.brKartona,
        qr:
          this.proizvod +
          ';' +
          this.proizvodSifra +
          ';' +
          paleta.lot +
          ';' +
          paleta.rBroj +
          ';' +
          paleta.brKomada +
          ';' +
          paleta.brKartona +
          ';' +
          paleta.sifraPoslovnice +
          ';' +
          paleta.idPalete +
          ';' +
          paleta.radniNalog +
          ';' +
          this.idPlan +
          ';' +
          paleta.status +
          ';' +
          paleta.idArtikl,
        fit: '150',
        alignment: 'center',
      });
      
      ct.push({ text: '\n' });
      ct.push({ text: 'Šifra proizvoda: ' + this.proizvodSifra });
      ct.push({ text: 'Naziv: ' + this.proizvod, fontSize: 13 });
      ct.push({ text: 'LOT: ' + paleta.lot });
      ct.push({ text: 'Status palete: ' + paleta.status });
      ct.push({
        text: 'Redni broj palete: ' + paleta.rBroj,
        pageBreak: paleta.rBroj === 1 ? '' : 'after',
      });
      if (paleta.lot !== null) {
        var imaLot = true;
      }
    }
    this.docDefinition = {
      info: { title: this.proizvodSifra + ' ' + this.proizvod },
      pageSize: { width: 226, height: 283 },
      pageMargins: [10, 10, 10, 10],
      content: ct,
    };
    if (imaLot) {
      pdfMake.createPdf(this.docDefinition).open();
      this.service
        .oznacitiIspisaneNaljepnice({ idplanproizvodnje: this.idPlan })
        .subscribe((res) => {
          console.log(res);
          if (res.success === true) {
            if (this.glavniIspis) {
              this.prikaziPaletePopupVisible = false;
              this.glavniIspis = false;
            } else {
              this.dohvatiPalete(this.idPlan);
            }
          }
        });
    } else {
      notify('Nije moguće ispisati, palete nemaju LOT!', 'warning', 3000);
    }
  }

  noveNaljepnice() {
    this.popupDodajNoveNaljepniceZaIspisVisible = true;
    this.dohvatiNoveNaljepnice();

    this.filtriraniBarkodovi = [];
    this.sifraArtikla = '';
    this.kartonKolicina = '';
    this.kolicinaKartonaNaPaleti = '';
    this.nazivArtikla = '';
    this.odabraniBarkod = '';
    this.zaNarudzbu = false;
  }

  onChangeIdPlan(e) {
    // console.log(e);
    this.odabraniIdPlan = e.value;
    // console.log(this.odabraniIdPlan);

    this.filtriraniBarkodovi = [];
    for (let i = 0; i < this.noveNalijepnice.length; i++) {
      if (this.odabraniIdPlan === this.noveNalijepnice[i].idPlan) {
        this.filtriraniBarkodovi.push(this.noveNalijepnice[i]);
      }
    }

    for (let i = 0; i < this.noveNalijepnice.length; i++) {
      if (this.odabraniIdPlan === this.noveNalijepnice[i].idPlan) {
        this.sifraArtikla = this.noveNalijepnice[i].sifraArtikla;
        this.nazivArtikla = this.noveNalijepnice[i].nazivArtikla;
      }
    }
  }

  onChangeBarkodArtikla(e) {
    // console.log(e);
    this.odabraniBarkod = e.value.barkodArtikla;
    // console.log(this.odabraniBarkod);

    for (let i = 0; i < this.noveNalijepnice.length; i++) {
      if (
        this.odabraniBarkod === this.noveNalijepnice[i].barkodArtikla &&
        this.odabraniIdPlan === this.noveNalijepnice[i].idPlan
      ) {
        this.sifraArtikla = this.noveNalijepnice[i].sifraArtikla;
        if (this.sifraArtikla === null || this.sifraArtikla === undefined) {
          this.sifraArtikla = '';
          this.sifraArtiklaIsEmpty = true;
        } else {
          this.sifraArtiklaIsEmpty = false;
        }

        this.nazivArtikla = this.noveNalijepnice[i].nazivArtikla;
        if (this.nazivArtikla === null || this.nazivArtikla === undefined) {
          this.nazivArtikla = '';
          this.nazivArtiklaIsEmpty = true;
        } else {
          this.nazivArtiklaIsEmpty = false;
        }

        this.kartonKolicina = this.noveNalijepnice[i].kartonKolicina;
        if (this.kartonKolicina === null || this.kartonKolicina === undefined) {
          this.kartonKolicina = '';
          this.kartonKolicinaIsEmpty = true;
        } else {
          this.kartonKolicinaIsEmpty = false;
        }

        this.kolicinaKartonaNaPaleti =
          this.noveNalijepnice[i].kolicinaKartonaNaPaleti;
        if (
          this.kolicinaKartonaNaPaleti === null ||
          this.kolicinaKartonaNaPaleti === undefined
        ) {
          this.kolicinaKartonaNaPaleti = '';
          this.kolicinaKartonaNaPaletiIsEmpty = true;
        } else {
          this.kolicinaKartonaNaPaletiIsEmpty = false;
        }

        this.zaNarudzbu = this.noveNalijepnice[i].zaNarudzbu;

        this.kolicinaOdabranogArtikla = this.noveNalijepnice[i].kolicina;
        this.idOdabranogArtikla = this.noveNalijepnice[i].idArtikl;
        this.idBarkodOdabranogArtikla = this.noveNalijepnice[i].idBarkoda;
      }
    }
  }

  onChangeKolicinaKartonaNaPaleti(e) {
    // console.log(e);
    this.kolicinaKartonaNaPaleti = e.value;
  }

  onChangeKolicinaKartona(e) {
    //console.log(e);
    this.kartonKolicina = e.value;
  }

  displayExpression(data) {
    if (data) {
      if (data.zaNarudzbu == 1) {
        return data.barkodArtikla + ' - ZA NARUDŽBU';
      } else return data.barkodArtikla;
    }
  }

  dohvatiNoveNaljepnice() {
    this.poruka = 'Učitavanje...';
    this.noveNalijepnice = [];
    this.noviPlanovi = [];
    this.service.dohvatiNoveNaljepnice({ datum: this.odabraniDatum, smjena: this.smjena }).subscribe((res) => {
      if (res.success === true) {
        // console.log(res);
      }

      let index = -1;
      for (let i = 0; i < res.data.length; i++) {
        index = this.noviPlanovi.findIndex(function (x) {
          if (x.idplan === res.data[i].idplan) {
            return x;
          }
        });
        if (index == -1) {
          this.noviPlanovi.push(res.data[i]);
        }
      }

      // console.log(this.noviPlanovi);

      for (let data of res.data) {
        this.noveNalijepnice.push({
          barkodArtikla: data.barkod,
          kolicina: data.kolicina,
          zaNarudzbu: data.zanarudzbu,
          idArtikl: data.idartikl,
          kartonKolicina: data.karton,
          kolicinaKartonaNaPaleti: data.paleta,
          sifraArtikla: data.arsifra,
          idPlan: data.idplan,
          idPlanPrikaz: data.idplan,
          idBarkoda: data.idbarkoda,
          nazivArtikla: data.arnaziv,
        });
      }

      // console.log('NOVE NALIJEPNICE: ', this.noveNalijepnice);

      if (this.noveNalijepnice.length > 0) {
        this.poruka = 'Učitavanje...';
      } else {
        this.poruka = 'Nema podataka za prikaz!';
      }
    });
  }

  odustaniOdIzmjena() {
    this.popupDodajNoveNaljepniceZaIspisVisible = false;

    this.odabraniBarkod = '';
    this.kolicinaOdabranogArtikla = '';
    this.zaNarudzbu = false;
    this.idOdabranogArtikla = '';
    this.kartonKolicina = '';
    this.kolicinaKartonaNaPaleti = '';
    this.sifraArtikla = '';
    this.idPlan = '';
    this.idBarkodOdabranogArtikla = '';
    this.nazivArtikla = '';
    this.filtriraniBarkodovi = [];
    this.barkodArtikla = '';
  }

  spremiIzmjene() {
    let podaciZaSlanje = {
      barkod: this.odabraniBarkod,
      kolicina: this.kolicinaOdabranogArtikla,
      zanarudzbu: this.zaNarudzbu,
      idartikl: this.idOdabranogArtikla,
      karton: this.kartonKolicina,
      paleta: this.kolicinaKartonaNaPaleti,
      arsifra: this.sifraArtikla,
      idplanproizvodnje: this.idPlan,
      idbarkoda: this.idBarkodOdabranogArtikla,
      arnaziv: this.nazivArtikla,
      // idpartner:
    };
    // console.log('PODACI ZA SLANJE: ', podaciZaSlanje);

    this.service.spremiIzmjeneProizvoda(podaciZaSlanje).subscribe((res) => {
      // console.log('RES: ', res);
      if (res.success == true) {
        notify(
          'Uspješno ste kreirali novu naljepnicu za ispis...',
          'success',
          3000
        );
        // console.log('ODABRANI DATUM: ', this.odabraniDatum);
        // console.log('SMJENA: ', this.smjena);

        this.dohvatiNaljepnice(this.odabraniDatum, this.smjena);
      } else {
        notify(res.message, 'error', 3000);
      }
    });

    this.popupDodajNoveNaljepniceZaIspisVisible = false;

    this.odabraniBarkod = '';
    this.kolicinaOdabranogArtikla = '';
    this.zaNarudzbu = false;
    this.idOdabranogArtikla = '';
    this.kartonKolicina = '';
    this.kolicinaKartonaNaPaleti = '';
    this.sifraArtikla = '';
    this.idPlan = '';
    this.idBarkodOdabranogArtikla = '';
    this.nazivArtikla = '';
    this.filtriraniBarkodovi = [];
    this.barkodArtikla = '';
  }
}
